<script lang="ts">
	import { page } from '$app/stores';
	import { clickoutside } from '@svelte-put/clickoutside';
	import { createFloatingActions } from 'svelte-floating-ui';
	import { offset, shift } from 'svelte-floating-ui/core';
	import { flip } from 'svelte-floating-ui/dom';
	import { fly } from 'svelte/transition';
	import Modal from '../Modal.svelte';
	import ChangePasswordPanel from '@components/auth/ChangePasswordPanel.svelte';
	import LogoutButton from './LogoutButton.svelte';
	import { twMerge } from 'tailwind-merge';

	const { profile } = $page.data;
	const uiAvatarName = profile?.name.split(' ').join('+');

	let className = '',
		isShowPanel = false,
		pictureClass = '',
		isClickable = true;

	export { className as class, isShowPanel, pictureClass, isClickable };

	const [floatingRef, floatingContent] = createFloatingActions({
		strategy: 'absolute',
		placement: 'bottom',
		middleware: [flip(), shift({ crossAxis: true, padding: 20 }), offset(6)]
	});

	const links = [
		{
			label: 'Perpustakaan Saya',
			path: '/my-library'
		},
		{
			label: 'Histori Transaksi',
			path: '/transactions'
		},
		{
			label: 'Buku Favorit',
			path: '/favorites'
		},
		{
			label: 'Ganti Password',
			panel: ChangePasswordPanel
		},
		{
			label: 'Redeem',
			path: '/redeem'
		},
		{
			label: 'Nonaktifkan Akun',
			path: `/deactivate-account?username=${profile?.email ?? ''}`
		},
		{
			label: 'Hapus Akun',
			path: `/delete-account?username=${profile?.email ?? ''}`
		}
	];

	let modalEl: HTMLDialogElement,
		activeLinkId: number | null = null;

	function setActiveLink(index: number) {
		activeLinkId = index;
		modalEl.showModal();
	}
</script>

{#if profile}
	<div
		class="flex items-center {className}"
		use:clickoutside
		on:clickoutside={() => isShowPanel && (isShowPanel = false)}
	>
		<button
			use:floatingRef
			type="button"
			on:click={() => isClickable && (isShowPanel = !isShowPanel)}
			class="avatar"
			title={profile.name}
		>
			<div class={twMerge('size-12 rounded-full', pictureClass)}>
				<img
					src="https://ui-avatars.com/api/?background=2EC1CE&color=fff&name={uiAvatarName}"
					alt={profile.name}
				/>
			</div>
		</button>
		<slot name="details" />
		{#if isShowPanel}
			<div
				transition:fly={{ y: 10 }}
				use:floatingContent
				class="absolute w-full max-w-56 rounded-xl bg-base-100 p-5 shadow-soft"
			>
				<div class="overflow-hidden border-b border-gray-300 pb-3">
					<p class="text-balance font-medium">{profile.name}</p>
					<p class="mt-1 min-w-0 truncate text-xs text-gray-500" title={profile.email}>
						{profile.email}
					</p>
				</div>
				<ul class="mt-3 text-sm">
					{#each links as link, index}
						{@const isActive = link.path && $page.url.pathname.includes(link.path)}
						<li>
							{#if link.path}
								<a href={link.path} class="avatar-link" class:active={isActive}>
									{link.label}
								</a>
							{:else}
								<button
									on:click={() => setActiveLink(index)}
									type="button"
									class="avatar-link"
									class:active={isActive}
								>
									{link.label}
								</button>
							{/if}
						</li>
					{/each}
					<li>
						<LogoutButton />
					</li>
				</ul>
			</div>
		{/if}
		<Modal bind:modalEl on:close={() => (activeLinkId = null)}>
			{#if activeLinkId !== null}
				{@const activeLink = links[activeLinkId]}
				<svelte:component this={activeLink.panel} bind:modalEl bind:isShowPanel />
			{/if}
		</Modal>
	</div>
{/if}

<style lang="postcss">
	.avatar-link {
		@apply btn-block block rounded-md px-3 py-2 text-left hover:bg-base-200/30;

		&.active {
			@apply bg-primary/10 text-primary;
		}
	}
</style>
